import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

// 商户资产报表
export const getBalance = (params: any) =>
  request({
    url: '/manage/merchant/balance/report',
    method: 'get',
    params
  })

// 资产报表导出
export const balanceExport = (data: any) =>
  request({
    url: '/manage/merchant/balance/report/export' + objToUrlParams(data),
    method: 'post'
  })

// 获取商户交易报表
export const getTransaction = (params: any) =>
  request({
    url: '/manage/merchant/transaction/report',
    method: 'get',
    params
  })

// 商户交易报表导出
export const transactionExport = (data: any) =>
  request({
    url: '/manage/merchant/transaction/report/export' + objToUrlParams(data),
    method: 'post'
  })

// 返佣报表
export const antRebateReportlist = (params: any) =>
  request({
    url: '/manage/ant-rebate-report',
    method: 'get',
    params
  })

// 平台报表
export const antPlatformReportlist = (params: any) =>
  request({
    url: '/manage/ant-daily-report',
    method: 'get',
    params
  })

// 导出平台报表
export const platformExport = (data: any) =>
  request({
    url: '/manage/ant-daily-report/export' + objToUrlParams(data),
    method: 'post'
  })

// 机器人上分数据
export const botPictureList = (params: any) =>
  request({
    url: '/manage/ant-tele-picture-ocr',
    method: 'get',
    params
  })

// 蚂蚁上分数据报表导出
export const getAntOrcExport = (data: any) =>
  request({
    url: `/manage/ant-tele-picture-ocr-data/export`,
    method: 'post',
    data
  })

// 蚂蚁上分数据报表导出
export const getPictureOcrExport = (data: any) =>
  request({
    url: `/manage/ant-tele-picture-ocr-exchange/export`,
    method: 'post',
    data
  })

// 代理佣金列表
export const agentList = (params: any) =>
  request({
    url: '/manage/merchant/agent-rebate',
    method: 'get',
    params
  })

// 代理佣金详情
export const agentDetail = (params: any) =>
  request({
    url: `/manage/merchant/${params.merchant_no}/descendants/${params.day}/rebate`,
    method: 'get'
  })
